import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import useChangePassword from './useChangePassword';
interface IChangePassword {
  show: boolean;
  onHide: () => void;
}

const ChangePassword = ({ show, onHide }: IChangePassword) => {
  const {
    currentPassword,
    setCurrentPassword,
    newPassword,
    confirmPassword,
    passwordError,
    confirmPasswordError,
    handleNewPasswordChange,
    handleConfirmPasswordChange,
    handlePasswordChange,
    loading,
  } = useChangePassword(onHide);
  return (
    <Modal
      show={show}
      onHide={onHide}
      className='modal-container move-device-modal'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Change Password</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className='mb-3'>
            <Form.Label>Current Password</Form.Label>
            <Form.Control
              type='password'
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
            />
          </Form.Group>

          <Form.Group className='mb-3'>
            <Form.Label>New Password</Form.Label>
            <Form.Control
              type='password'
              value={newPassword}
              onChange={handleNewPasswordChange}
            />
            {passwordError && <p style={{ color: 'red' }}>{passwordError}</p>}
          </Form.Group>

          <Form.Group className='mb-3'>
            <Form.Label>Confirm New Password</Form.Label>
            <Form.Control
              type='password'
              value={confirmPassword}
              onChange={handleConfirmPasswordChange}
            />
            {confirmPasswordError && (
              <p style={{ color: 'red' }}>{confirmPasswordError}</p>
            )}
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button className='btn-cancel' onClick={onHide}>
          Cancel
        </Button>
        <Button
          className='btn-style'
          onClick={handlePasswordChange}
          disabled={loading}
        >
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChangePassword;
